import { useState, useEffect } from 'react';
import isEqual from 'lodash/isEqual'; 
import RecentInsightsQuran from './RecentInsightsQuran';
import RecentInsightsKidsQuran from './RecentInsightsKidsQuran';
import RecentInsightsTranslation from './RecentInsightsTranslation';
import RecentInsightsTafsir from './RecentInsightsTafsir';
import RecentInsightsSkelton from './RecentInsightsSkelton';

const fallbackValue = [
    {
        "surahNumber": "001",
        "titleMeaning": "The Opening",
        "title": "Al-Fatiha",
        "arbTitle": "الفاتحة",
        "ayahCount": "7",
        "juz": "01",
        "scrollPos": "1",
        "pageType": "recite-surah"
    },
    {
        "surahNumber": "036",
        "titleMeaning": "Yaseen",
        "title": "Yasin",
        "arbTitle": "يس",
        "ayahCount": "83",
        "juz": "22",
        "scrollPos": "1",
        "pageType": "recite-surah"
    },
    {
        "surahNumber": "056",
        "titleMeaning": "The Inevitable",
        "title": "Al-Waqi'ah",
        "arbTitle": "الواقعة",
        "ayahCount": "96",
        "juz": "27",
        "scrollPos": "1",
        "pageType": "recite-surah"
    },
    {
        "surahNumber": "055",
        "titleMeaning": "The Beneficent",
        "title": "Ar-Rahman",
        "arbTitle": "الرحمن",
        "ayahCount": "78",
        "juz": "27",
        "scrollPos": "1",
        "pageType": "recite-surah"
    },
    {
        "surahNumber": "046",
        "titleMeaning": "The Wind-Curved Sandhills",
        "title": "Al-Ahqaf",
        "arbTitle": "الأحقاف",
        "ayahCount": "35",
        "juz": "26",
        "scrollPos": "1",
        "pageType": "recite-surah"
    },
    {
        "surahNumber": "044",
        "titleMeaning": "The Smoke",
        "title": "Ad-Dukhan",
        "arbTitle": "الدخان",
        "ayahCount": "59",
        "juz": "25",
        "scrollPos": "1",
        "pageType": "recite-surah"
    },
    {
        "surahNumber": "112",
        "titleMeaning": "Sincerity",
        "title": "Al-Ikhlas",
        "arbTitle": "الإخلاص",
        "ayahCount": "4",
        "juz": "30",
        "scrollPos": "1",
        "pageType": "recite-surah"
    }
];

const fallbackValueTafsir=[
    {
        "surahNumber":"001",
        "titleMeaning":"The Opening",
        "title":"Al-Fatiha",
        "arbTitle":"الفاتحة",
        "ayahCount":"7",
        "juz":"01",
        "scrollPos":"0",
        "type":"ibn-kathir"
    },
    {
        "surahNumber":"036",
        "titleMeaning":"Yaseen",
        "title":"Yasin",
        "arbTitle":"يس",
        "ayahCount":"83",
        "juz":"22",
        "scrollPos":"0",
        "type":"ibn-kathir"
    },
    {
        "surahNumber":"056",
        "titleMeaning":"The Inevitable",
        "title":"Al-Waqi'ah",
        "arbTitle":"الواقعة",
        "ayahCount":"96",
        "juz":"27",
        "scrollPos":"0",
        "type":"ibn-kathir"
    },
    {
        "surahNumber":"055",
        "titleMeaning":"The Beneficent",
        "title":"Ar-Rahman",
        "arbTitle":"الرحمن",
        "ayahCount":"78",
        "juz":"27",
        "scrollPos":"0",
        "type":"ibn-kathir"
    },
    {
        "surahNumber":"046",
        "titleMeaning":"The Wind-Curved Sandhills",
        "title":"Al-Ahqaf",
        "arbTitle":"الأحقاف",
        "ayahCount":"35",
        "juz":"26",
        "scrollPos":"0",
        "type":"ibn-kathir"
    },
    {
        "surahNumber":"044",
        "titleMeaning":"The Smoke",
        "title":"Ad-Dukhan",
        "arbTitle":"الدخان",
        "ayahCount":"59",
        "juz":"25",
        "scrollPos":"0",
        "type":"ibn-kathir"
    },
    {
        "surahNumber":"112",
        "titleMeaning":"Sincerity",
        "title":"Al-Ikhlas",
        "arbTitle":"الإخلاص",
        "ayahCount":"4",
        "juz":"30",
        "scrollPos":"0",
        "type":"ibn-kathir"
    }
];

const fallbackValueTranslation=[
    {
        "surahNumber":"001",
        "titleMeaning":"The Opening",
        "title":"Al-Fatiha",
        "arbTitle":"الفاتحة",
        "ayahCount":"7",
        "juz":"01",
        "type":"asad"
    },
    {
        "surahNumber":"036",
        "titleMeaning":"Yaseen",
        "title":"Yasin",
        "arbTitle":"يس",
        "ayahCount":"83",
        "juz":"22",
        "type":"asad"
    },
    {
        "surahNumber":"056",
        "titleMeaning":"The Inevitable",
        "title":"Al-Waqi'ah",
        "arbTitle":"الواقعة",
        "ayahCount":"96",
        "juz":"27",
        "type":"asad"
    },
    {
        "surahNumber":"055",
        "titleMeaning":"The Beneficent",
        "title":"Ar-Rahman",
        "arbTitle":"الرحمن",
        "ayahCount":"78",
        "juz":"27",
        "type":"asad"
    },
    {
        "surahNumber":"046",
        "titleMeaning":"The Wind-Curved Sandhills",
        "title":"Al-Ahqaf",
        "arbTitle":"الأحقاف",
        "ayahCount":"35",
        "juz":"26",
        "type":"asad"
    },
    {
        "surahNumber":"044",
        "titleMeaning":"The Smoke",
        "title":"Ad-Dukhan",
        "arbTitle":"الدخان",
        "ayahCount":"59",
        "juz":"25",
        "type":"asad"
    },
    {
        "surahNumber":"112",
        "titleMeaning":"Sincerity",
        "title":"Al-Ikhlas",
        "arbTitle":"الإخلاص",
        "ayahCount":"4",
        "juz":"30",
        "type":"asad"
    }
];

const fallbackValueKidsQuran=[
    {
        "surahNumber":"001",
        "titleMeaning":"The Opening",
        "title":"Al-Fatiha",
        "arbTitle":"الفاتحة",
        "ayahCount":"7",
        "juz":"1",
        "scrollPos":"1",
        "pageType":"recite-surah"
    },
    {
        "surahNumber":"099",
        "titleMeaning":"The Earthquake",
        "title":"Az-Zalzalah",
        "arbTitle":"الزلزلة",
        "ayahCount":"8",
        "juz":"30",
        "scrollPos":"1",
        "pageType":"recite-surah"
    },
    {
        "surahNumber":"108",
        "titleMeaning":"Abundance",
        "title":"Al-Kauthar",
        "arbTitle":"الكوثر",
        "ayahCount":"3",
        "juz":"30",
        "scrollPos":"1",
        "pageType":"recite-surah"
    },
    {
        "surahNumber":"110",
        "titleMeaning":"Divine Support",
        "title":"An-Nasr",
        "arbTitle":"النصر",
        "ayahCount":"3",
        "juz":"30",
        "scrollPos":"1",
        "pageType":"recite-surah"
    },
    {
        "surahNumber":"112",
        "titleMeaning":"Sincerity",
        "title":"Al-Ikhlas",
        "arbTitle":"الإخلاص",
        "ayahCount":"4",
        "juz":"30",
        "scrollPos":"1",
        "pageType":"recite-surah"
    },
    {
        "surahNumber":"113",
        "titleMeaning":"The Dawn",
        "title":"Al-Falaq",
        "arbTitle":"الفلق",
        "ayahCount":"5",
        "juz":"30",
        "scrollPos":"1",
        "pageType":"recite-surah"
    },
    {
        "surahNumber":"114",
        "titleMeaning":"Mankind",
        "title":"An-Nas",
        "arbTitle":"الناس",
        "ayahCount":"6",
        "juz":"30",
        "scrollPos":"1",
        "pageType":"recite-surah"
    }
];

const RecentInsights=({haveBorder="0", pageType="quran"} = {})=>{
    const [recentInsightsArr, setRecentInsightsArr] = useState(null);

    useEffect(() => {
        // Ensure this runs only in the browser
        if (typeof window !== 'undefined' && typeof localStorage !== 'undefined') {
            if(pageType==="tafsir")
            {
                const storedData = localStorage.getItem('recentTafsir');
                
                if (!storedData) {
                    localStorage.setItem('recentTafsir', JSON.stringify(fallbackValueTafsir));
                    setRecentInsightsArr(fallbackValueTafsir);
                } else {
                    setRecentInsightsArr(JSON.parse(storedData));
                }
            }
            else if(pageType==="translation")
            {
                const storedData = localStorage.getItem('recentTranslation');
                if (!storedData) {
                    localStorage.setItem('recentTranslation', JSON.stringify(fallbackValueTranslation));
                    setRecentInsightsArr(fallbackValueTranslation);
                } else {
                    setRecentInsightsArr(JSON.parse(storedData));
                }
            }
            else if(pageType==="kids-quran")
            {
                const storedData = localStorage.getItem('recentInsightsKids');
                if (!storedData) {
                    localStorage.setItem('recentInsightsKids', JSON.stringify(fallbackValueKidsQuran));
                    setRecentInsightsArr(fallbackValueKidsQuran);
                } else {
                    setRecentInsightsArr(JSON.parse(storedData));
                }
            }
            else
            {
                const storedData = localStorage.getItem('recentInsights');
                if (!storedData) {
                    localStorage.setItem('recentInsights', JSON.stringify(fallbackValue));
                    setRecentInsightsArr(fallbackValue);
                } else {
                    setRecentInsightsArr(JSON.parse(storedData));
                }
            }
        }
    }, []);

    return(
        <>
            <p className="alim-text-color-style text-base mt-6 mb-3 font-medium">{isEqual(recentInsightsArr, fallbackValue)||isEqual(recentInsightsArr, fallbackValueTafsir)||isEqual(recentInsightsArr, fallbackValueTranslation)||isEqual(recentInsightsArr, fallbackValueKidsQuran)?`Popular surahs`:`Recent insights`}</p>
            <div className={`grid  grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-3 md:gap-5 ${haveBorder==="0"?``:`border-b border-light-gr-border dark:border-light-blue`} pb-10 insight-block-cont`}>
                {
                    pageType==="quran"&&recentInsightsArr?
                        <RecentInsightsQuran recentInsightsArr={recentInsightsArr}/>
                    :
                        null
                }
                {
                    pageType==="kids-quran"&&recentInsightsArr?
                        <RecentInsightsKidsQuran recentInsightsArr={recentInsightsArr}/>
                    :
                        null
                }
                {
                    pageType==="tafsir"&&recentInsightsArr?
                        <RecentInsightsTafsir recentInsightsArr={recentInsightsArr}/>
                    :
                        null
                }
                {
                    pageType==="translation"&&recentInsightsArr?
                        <RecentInsightsTranslation recentInsightsArr={recentInsightsArr}/>
                    :
                        null
                }
                {
                    recentInsightsArr?
                        null
                    :
                        <RecentInsightsSkelton/>
                }  
            </div>
        </>
    );
}

export default RecentInsights;